import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { TAB } from '@angular/cdk/keycodes';
import { MatLegacyChipInputEvent as MatChipInputEvent } from '@angular/material/legacy-chips';
import { MatLegacyAutocompleteSelectedEvent as MatAutocompleteSelectedEvent } from '@angular/material/legacy-autocomplete';
import { Observable, debounceTime, filter, switchMap } from 'rxjs';

import { Store } from '@ngxs/store';
import { OnDestroyMixin, untilComponentDestroyed } from '@w11k/ngx-componentdestroyed';
import { Dictionary } from 'app/shared/models';
import { AccountService } from 'app/core';
import { Account } from 'app/core/models';
import { AccountState } from 'app/state/account/state';
import { RelatedToType } from 'app/shared/enums';

@Component({
  selector: 'app-custom-tag-list',
  templateUrl: './custom-tag-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomTagListComponent extends OnDestroyMixin implements OnInit {
  private account: Account;

  selectedTags: string[] = [];
  tagsSearchResult$: Observable<Dictionary<number>>;
  addTagInputCtrl = new FormControl('');
  separatorKeysCodes: number[] = [TAB];

  @ViewChild('tagsInput') tagsInput: ElementRef<HTMLInputElement>;

  @Input() relatedToType: RelatedToType;
  @Input() readonly: boolean;

  @Output() onValueChanged = new EventEmitter<{ tag_list: string[] }>();

  constructor(
    private readonly accountService: AccountService,
    private readonly store: Store,
  ) {
    super();
  }
  ngOnInit(): void {
    this.account = this.store.selectSnapshot(AccountState.getAccount);
    this.searchTags();
  }

  private searchTags(): void {
    this.tagsSearchResult$ = this.addTagInputCtrl.valueChanges.pipe(
      untilComponentDestroyed(this),
      debounceTime(300),
      filter((value: string) => !!(value || '').trim()),
      switchMap((query: string) => this.accountService.getAccountTags(this.relatedToType, query)),
    );
  }

  private clearTagsInput(): void {
    this.tagsInput.nativeElement.value = '';
    this.addTagInputCtrl.setValue('');
  }

  public addTag(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    if (value) {
      this.selectedTags.push(value);
      this.onValueChanged.emit({ tag_list: this.selectedTags });
    }
    event.chipInput!.clear();
    this.clearTagsInput();
  }

  public removeTag(tag: string): void {
    const index = this.selectedTags.indexOf(tag);
    if (index >= 0) {
      this.selectedTags.splice(index, 1);
      this.onValueChanged.emit({ tag_list: this.selectedTags });
    }
  }

  public selectedTag({ option }: MatAutocompleteSelectedEvent): void {
    this.selectedTags.push(option.viewValue);
    this.onValueChanged.emit({ tag_list: this.selectedTags });
    this.clearTagsInput();
  }
}
